import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appToLowercase]'
})
export class ToLowercaseDirective {

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toLowerCase();
    this.control.control.patchValue(input.value);
  }
}
